<template>
  <div style="width: 100%;height: 100%">
    <PageHeader :service="true"/>
    <div class="content" style="width: 100%;height: calc(100% - 60px)">
      <div style="width: 100%;height: 100%;background-color: #f0f2f5;padding-top: 24px">
        <router-view ref="content"/>
        <GlobalFooter></GlobalFooter>
      </div>
    </div>

  </div>
</template>

<script>
import PageHeader from '@/customComponents/PageHeader'
import GlobalFooter from '@/components/GlobalFooter'

export default {
  name: 'IndependentServiceLayout',
  components: { PageHeader, GlobalFooter },
  props: {},
  data() {
    return {
      pageTitle: null,
      logo: null
    }
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped>
</style>